import React, {Component} from 'react';
import PropTypes from 'prop-types';
import IgniteDataTable from '../../../../common/datatable/index';

const columns = [
  {
    prop: 'title',
    title: 'Title',
  },
  {
    prop: 'content',
    title: 'content'
  },
  {
    prop: 'groups',
    title: 'Groups',
    format: data => data.join(', ')
  }
];

class PushNotificationsTable extends Component {
  isSystemTriggered = (cell, row) => row.attributes['system-trigger'] !== '1';

  constructor(props) {
    super(props);
    const {onDelete, onEdit, onPush} = this.props;

    this.actions = [
      {
        label: 'Delete',
        callback: (row) => {
          onDelete(row.id);
        },
        render: this.isSystemTriggered,
        permissions: {
          action: 'remove',
          subjectClass: 'PushNotificationTemplate',
        }
      },
      {
        label: 'Edit',
        callback: (row) => {
          onEdit(row.id);
        },
        permissions: {
          action: 'modify',
          subjectClass: 'PushNotificationTemplate',
        }
      },
      {
        label: 'Push',
        callback: (row) => {
          onPush(row.id);
        },
        render: this.isSystemTriggered,
        permissions: {
          action: 'add',
          subjectClass: 'PushNotification',
        }
      },
    ];
  }

  render() {
    const {notifications} = this.props;
    return (
      <div>
        <IgniteDataTable data={notifications} columns={columns} actions={this.actions}/>
      </div>
    );
  }
}

PushNotificationsTable.propTypes = {
  notifications: PropTypes.array.isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onPush: PropTypes.func.isRequired,
};

export default PushNotificationsTable;



// WEBPACK FOOTER //
// ./src/components/admin/app/push-notifications/templates/push-notifications-table.jsx